export default "__VITE_ASSET__DfhSOdqD__"